_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[119],{

/***/ "+wNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ "8K1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("XcBm");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(subClass, superClass);
}

/***/ }),

/***/ "9fIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "HbGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutProperties; });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("+wNj");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),

/***/ "K/z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4wDe");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pWxA");


function _possibleConstructorReturn(self, call) {
  if (call && (Object(_typeof_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return Object(_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(self);
}

/***/ }),

/***/ "LHH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "__N_SSP", function() { return /* binding */ __N_SSP; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/seo/FacebookAndTwitterSeoHeaderMeta.jsx
var FacebookAndTwitterSeoHeaderMeta = __webpack_require__("LaX8");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.jsx + 6 modules
var FacetSearch = __webpack_require__("ontP");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/routes/constants.js
var constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/views/search/SearchView.jsx




var __jsx = react_default.a.createElement;














var SearchView_SearchView = function SearchView(_ref) {
  var _config$searchPage, _config$searchPage2, _config$searchPage3, _config$searchPage4, _config$searchPage5;

  var config = _ref.config;
  Object(i18n["a" /* addTranslationKeys */])(config);
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var origin = Object(uriUtils["c" /* convertUrlToOrigin */])(appContext.originalUrl);
  var currentUri = origin + router.asPath;
  Object(react["useEffect"])(function () {
    setTimeout(function () {
      return Object(scrollToElement["a" /* scrollToElement */])('.Line-ProductsFilters', 100, '.Navigation-bar');
    }, 2000);
  }, []);
  var isFeatureFlipped = featureFlippingUtils["a" /* isFeatureFlipped */](appContext);
  return __jsx(react["Fragment"], null, __jsx(head_default.a, null, __jsx("title", {
    key: "title"
  }, (config === null || config === void 0 ? void 0 : (_config$searchPage = config.searchPage) === null || _config$searchPage === void 0 ? void 0 : _config$searchPage.title) || ''), __jsx("meta", {
    name: "description",
    content: (config === null || config === void 0 ? void 0 : (_config$searchPage2 = config.searchPage) === null || _config$searchPage2 === void 0 ? void 0 : _config$searchPage2.description) || ''
  })), __jsx(FacebookAndTwitterSeoHeaderMeta["a" /* FacebookAndTwitterSeoHeaderMeta */], {
    description: (config === null || config === void 0 ? void 0 : (_config$searchPage3 = config.searchPage) === null || _config$searchPage3 === void 0 ? void 0 : _config$searchPage3.description) || '',
    immersiveUrl: (config === null || config === void 0 ? void 0 : (_config$searchPage4 = config.searchPage) === null || _config$searchPage4 === void 0 ? void 0 : _config$searchPage4.immersiveImage) || '',
    title: (config === null || config === void 0 ? void 0 : (_config$searchPage5 = config.searchPage) === null || _config$searchPage5 === void 0 ? void 0 : _config$searchPage5.title) || '',
    url: currentUri.toString()
  }), __jsx("main", {
    className: "Line Line-ProductsFilters min-h-[80vh] mt-navigation",
    role: "main"
  }, __jsx(FacetSearch["FacetSearch"], {
    i18n: config,
    isProductComparisonModeAuthorized: isFeatureFlipped('search.productComparison'),
    initialIsSearchEnabled: true,
    fullScreen: true,
    shouldPersistCriteriaInUrl: true,
    shouldSetDefaultDepartureCityOnCompare: true,
    withSearchFacets: true,
    withSearchForm: true,
    withSearchResults: true,
    withWorldMap: isFeatureFlipped('search.worldMap')
  })));
};

SearchView_SearchView.pageId = constants["D" /* SEARCH_PAGE_ID */];
SearchView_SearchView.pageType = tracking_constants["x" /* STATIC_PAGE_TYPES */].SHOPPING_SEARCH;
SearchView_SearchView.disableHeader = sellerUtils["g" /* isSeller */];
SearchView_SearchView.disableFooter = sellerUtils["g" /* isSeller */];
/* harmony default export */ var search_SearchView = (SearchView_SearchView);
// CONCATENATED MODULE: ./pages/s.js

var __N_SSP = true;
/* harmony default export */ var s = __webpack_exports__["default"] = (search_SearchView);

/***/ }),

/***/ "LaX8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacebookAndTwitterSeoHeaderMeta; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fGyu");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("vpUC");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FLQK");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("1JJ2");
/* harmony import */ var _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("psNz");








var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;






var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["b2cPagesService"].PAGE_TYPES;
var FacebookAndTwitterSeoHeaderMeta = function FacebookAndTwitterSeoHeaderMeta(_ref) {
  var description = _ref.description,
      _ref$immersiveUrl = _ref.immersiveUrl,
      immersiveUrl = _ref$immersiveUrl === void 0 ? '' : _ref$immersiveUrl,
      lines = _ref.lines,
      _ref$pageType = _ref.pageType,
      pageType = _ref$pageType === void 0 ? '' : _ref$pageType,
      title = _ref.title,
      url = _ref.url;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_12__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;
  /**
   * Format immersive url for SEO
   * @param {string} urlImmersive The url to format
   * @returns The url formatted
   */


  var getImmersiveUrl = function getImmersiveUrl(urlImmersive) {
    return Object(_utils_media_server__WEBPACK_IMPORTED_MODULE_11__[/* getUrl */ "a"])({
      url: urlImmersive,
      width: 1200,
      height: 'auto',
      format: '_AUTOFORMAT_',
      quality: 70,
      transform: 'resize'
    });
  };

  var getFirstImmersiveUrl = function getFirstImmersiveUrl(allLines) {
    var immersives = [];

    var collectFn = function collectFn(line) {
      var _line$props$media;

      var backgroundURL = isDesktop ? line.props.backgroundURLDesktop : line.props.backgroundURLMobile;
      immersives = line.name === _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_13__[/* IMMERSIVE */ "s"] ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(immersives), [getImmersiveUrl(backgroundURL)]) : immersives;
      immersives = line.name === _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_13__[/* PRODUCT_IMMERSIVE */ "N"] && !!((_line$props$media = line.props.media) === null || _line$props$media === void 0 ? void 0 : _line$props$media.photos) ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(immersives), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(line.props.media.photos.map(function (p) {
        return getImmersiveUrl(p.url);
      }))) : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives && immersives.length > 0 ? immersives[0] : '';
  };

  var immersiveUrlFromLines = lines && lines.length > 0 ? getFirstImmersiveUrl(lines) : '';
  return __jsx(next_head__WEBPACK_IMPORTED_MODULE_8___default.a, null, __jsx("meta", {
    property: "og:type",
    content: "website"
  }), pageType !== PAGE_TYPES.CRUISE && pageType !== PAGE_TYPES.RESORT && pageType !== PAGE_TYPES.RESORT_MICE && __jsx("meta", {
    property: "og:title",
    content: title
  }), pageType !== PAGE_TYPES.CRUISE && __jsx("meta", {
    property: "og:description",
    content: description
  }), __jsx("meta", {
    property: "og:image",
    content: immersiveUrl || immersiveUrlFromLines
  }), __jsx("meta", {
    property: "og:url",
    content: url
  }), __jsx("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), pageType !== PAGE_TYPES.CRUISE && pageType !== PAGE_TYPES.RESORT && pageType !== PAGE_TYPES.RESORT_MICE && __jsx("meta", {
    name: "twitter:title",
    content: title
  }), pageType !== PAGE_TYPES.CRUISE && __jsx("meta", {
    name: "twitter:description",
    content: description
  }), __jsx("meta", {
    name: "twitter:image",
    content: immersiveUrl || immersiveUrlFromLines
  }), __jsx("meta", {
    name: "twitter:url",
    content: url
  }));
};

/***/ }),

/***/ "MMYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("DAgO");

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, Object(_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "XcBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "aPQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendErrorToSentry; });
/* unused harmony export shouldIgnore */
/* unused harmony export processError */
/* unused harmony export handleBrowserError */
/* unused harmony export handlePromiseError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleComponentError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return start; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wNDy");













var sanitize = function sanitize() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return s && s.trim().toLowerCase();
};

var sendErrorToSentry = function sendErrorToSentry(_ref) {
  var error = _ref.error,
      _ref$errorInfo = _ref.errorInfo,
      errorInfo = _ref$errorInfo === void 0 ? {} : _ref$errorInfo;

  if ( true && _config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.sentry.enabled')) {
    var _window$Sentry;

    (_window$Sentry = window.Sentry) === null || _window$Sentry === void 0 ? void 0 : _window$Sentry.withScope(function (scope) {
      var _window$Sentry2;

      Object.keys(errorInfo).forEach(function (key) {
        scope.setExtra(key, errorInfo[key]);
      });
      (_window$Sentry2 = window.Sentry) === null || _window$Sentry2 === void 0 ? void 0 : _window$Sentry2.captureException(error);
    });
  }
};
var shouldIgnore = function shouldIgnore(error) {
  var errorMessagesToIgnore = [].concat(_config__WEBPACK_IMPORTED_MODULE_9___default.a.get('clientError.ignore.descriptions'));
  var errorMessage = sanitize(error.message);
  var errorStack = sanitize(error.stack);
  return errorMessagesToIgnore.some(function (messageToIgnore) {
    var msg = sanitize(messageToIgnore);
    var isIgnored = !!msg && (!!errorMessage.includes(msg) || !!errorStack.includes(msg));
    return isIgnored;
  });
};
var processError = function processError(_ref2) {
  var error = _ref2.error,
      errorInfo = _ref2.errorInfo;
  _logger__WEBPACK_IMPORTED_MODULE_10___default.a.error({
    err: error,
    info: errorInfo
  });

  if (!shouldIgnore(error)) {
    sendErrorToSentry({
      error: error,
      errorInfo: errorInfo
    });
  }

  return error;
}; // eslint-disable-next-line max-params

var handleBrowserError = function handleBrowserError(message, file, line, col, error) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown error name',
      message: message || 'Unknown error message',
      stack: 'Unknown stack'
    }),
    errorInfo: {
      message: message,
      file: file,
      line: line,
      col: col
    }
  });
};
var handlePromiseError = function handlePromiseError(domCustomEvent) {
  return processError({
    error: lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'detail.reason', lodash_get__WEBPACK_IMPORTED_MODULE_8___default()(domCustomEvent, 'reason', new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown rejected promise name',
      message: 'Unknown rejected promise message',
      stack: ['Unknown stack']
    })))
  });
};
var handleComponentError = function handleComponentError(error, errorInfo) {
  return processError({
    error: error || new _errors__WEBPACK_IMPORTED_MODULE_11__[/* ClientSideError */ "c"]({
      name: 'Unknown component error name',
      message: 'Unknown component error message',
      stack: ['Unknown stack']
    }),
    errorInfo: errorInfo
  });
};
var start = function start() {
  window.onerror = handleBrowserError;
  window.addEventListener('unhandledrejection', handlePromiseError);
  window.addEventListener('rejectionhandled', handlePromiseError);
};

/***/ }),

/***/ "lWeT":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s",
      function () {
        return __webpack_require__("LHH8");
      }
    ]);
  

/***/ }),

/***/ "pWxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ "psNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BRAND_PROMISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BRAND_SUPERIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUTTON_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHECKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPARISON_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CRISIS_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CRUISE_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CRUISE_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DOWNLOAD_LINKS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EDITORIAL_FOLDING_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EVENT_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EVENT_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EXCLUSIVE_COLLECTION_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HAPPY_TO_CARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return INSPIRATIONAL_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LAST_SEEN_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MEDIA_TEXT_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MEDIA_TEXT_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MEDIA_THUMBNAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MUST_TRY_EXPERIENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NAVIGATION_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return NAVIGATION_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return OFFER_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return OFFER_LEGAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return OFFER_SEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return OFFERS_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return OFFERS_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PAGE_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PREBOOKING_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PRODUCT_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PRODUCT_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PRODUCT_CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PRODUCT_IMAGE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PRODUCT_IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCT_INFORMATION_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PRODUCT_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PRODUCT_SIGNATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PRODUCT_STREET_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PRODUCT_STRENGTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PRODUCTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PRODUCT_PRICE_TICKET_CUSTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PRODUCT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return QRCODE_PRODUCT_BARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return QRCODE_PRODUCT_DRESSCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return QRCODE_PRODUCT_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return QRCODE_PRODUCT_RESTAURANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return QUOTATION_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return RELATED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return RESORT_ACCESS_AND_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return RESORT_ACCOMMODATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return RESORT_BARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return RESORT_BOOKING_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return RESORT_DESTINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return RESORT_DISTRICT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return RESORT_FLASH_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jb", function() { return RESORT_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kb", function() { return RESORT_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return RESORT_MEETING_ROOM_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mb", function() { return RESORT_MULTIMEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return RESORT_PRICE_REMOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ob", function() { return RESORT_PRICE_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pb", function() { return RESORT_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qb", function() { return RESORT_RESTAURANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rb", function() { return RESORT_SEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sb", function() { return RESORT_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tb", function() { return RESORT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ub", function() { return RESORT_TRIPADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vb", function() { return SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wb", function() { return SECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xb", function() { return SMART_FAQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yb", function() { return SUBMISSION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zb", function() { return TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ab", function() { return TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bb", function() { return TEASER_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cb", function() { return TEST_AB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Db", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Eb", function() { return THEMATIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fb", function() { return TITLE_AND_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jb", function() { return TRAVEL_RESTRICTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gb", function() { return TOUR_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hb", function() { return TOUR_PRACTICAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ib", function() { return TOUR_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Kb", function() { return TRIPADVISOR_TESTIMONY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lb", function() { return VIDEO; });
var ALL_INCLUSIVE_PUSH = 'all-inclusive-push';
var BRAND_PROMISE = 'brand-promise';
var BRAND_SUPERIORITY = 'brand-superiority';
var BUTTON_TICKET = 'button-ticket';
var CHECKLIST = 'checklist';
var COMPARISON_TABLE = 'comparison-table';
var CRISIS_ALERT = 'crisis-alert';
var CRUISE_BOOKING = 'cruise-booking';
var CRUISE_PROGRAM = 'cruise-program';
var DESTINATIONS = 'destinations';
var DOWNLOAD_LINKS_LIST = 'download-links-list';
var EDITORIAL_FOLDING_BLOCK = 'editorial-folding-block';
var EVENT_ANIMATION = 'event-animation';
var EVENT_FORM = 'event-form';
var EXCLUSIVE_COLLECTION_SPACE = 'exclusive-collection-space';
var EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION = 'exclusive-collection-space-introduction';
var HAPPY_TO_CARE = 'happy-to-care';
var HIGHLIGHT = 'highlight';
var IMMERSIVE = 'immersive';
var INSPIRATIONAL_GRID = 'inspirational-grid';
var LAST_SEEN_PRODUCTS = 'last-seen-products';
var MEDIA_TEXT_HORIZONTAL = 'media-text-horizontal';
var MEDIA_TEXT_VERTICAL = 'media-text-vertical';
var MEDIA_THUMBNAIL = 'media-thumbnail';
var MUST_TRY_EXPERIENCES = 'must-try-experiences';
var NAVIGATION_TAB = 'navigation-tab';
var NAVIGATION_TABS = 'navigation-tabs';
var OFFER_DESCRIPTION = 'offer-description';
var OFFER_LEGAL_INFORMATION = 'offer-legal-information';
var OFFER_SEO = 'offer-seo';
var OFFERS_GRID = 'offers-grid';
var OFFERS_PUSH = 'offers-push';
var PAGE_TRACKING = 'page-tracking';
var PREBOOKING_FORM = 'prebooking-form';
var PRODUCT_ACTIVITIES = 'product-activities';
var PRODUCT_BREADCRUMB = 'product-breadcrumb';
var PRODUCT_CHILDCARES = 'product-childcares';
var PRODUCT_IMAGE_MAP = 'product-image-map';
var PRODUCT_IMMERSIVE = 'product-immersive';
var PRODUCT_INFORMATION_SUMMARY = 'product-information-summary';
var PRODUCT_SERVICES = 'product-services';
var PRODUCT_SIGNATURES = 'product-signatures';
var PRODUCT_STREET_VIEW = 'product-street-view';
var PRODUCT_STRENGTHS = 'product-strengths';
var PRODUCTS_FILTERS = 'products-filters';
var PRODUCT_PRICE_TICKET_CUSTOM = 'product-price-ticket-custom';
var PRODUCT_TAGS = 'product-tags';
var QRCODE_PRODUCT_BARS = 'qrcode-product-bars';
var QRCODE_PRODUCT_DRESSCODE = 'qrcode-product-dresscode';
var QRCODE_PRODUCT_PROGRAM = 'qrcode-product-program';
var QRCODE_PRODUCT_RESTAURANTS = 'qrcode-product-restaurants';
var QUOTATION_FORM = 'quotation-form';
var RELATED_PRODUCTS = 'related-products';
var RESORT_ACCESS_AND_MAP = 'resort-access-and-map';
var RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION = 'resort-accommodation-exclusivecollection';
var RESORT_ACCOMMODATION_TYPES = 'resort-accommodationTypes';
var RESORT_BARS = 'resort-bars';
var RESORT_BOOKING_BE = 'resort-bookingBE';
var RESORT_DESTINATION = 'resort-destination';
var RESORT_DISTRICT = 'resort-district';
var RESORT_FLASH_INFO = 'resort-flash-info';
var RESORT_GRID = 'resort-grid';
var RESORT_INTRODUCTION = 'resort-introduction';
var RESORT_MEETING_ROOM_INFO = 'resort-meeting-room-info';
var RESORT_MULTIMEDIA = 'resort-multimedia';
var RESORT_PRICE_REMOTE = 'resort-price-remote';
var RESORT_PRICE_TICKET = 'resort-price-ticket';
var RESORT_RECOMMENDATIONS = 'resort-recommendations';
var RESORT_RESTAURANTS = 'resort-restaurants';
var RESORT_SEO = 'resort-seo';
var RESORT_SUMMARY = 'resort-summary';
var RESORT_TAGS = 'product-tags';
var RESORT_TRIPADVISOR = 'resort-tripadvisor';
var SECTION = 'section';
var SECTIONS = 'sections';
var SMART_FAQ = 'smart-faq';
var SUBMISSION_STATUS = 'submission-status';
var TAB = 'tab';
var TABS = 'tabs';
var TEASER_CARDS = 'teaser-cards';
var TEST_AB = 'test-ab';
var TEXT = 'text';
var THEMATIC = 'thematic';
var TITLE_AND_TEXT = 'title-and-text';
var TRAVEL_RESTRICTIONS = 'travel-restrictions';
var TOUR_INTRODUCTION = 'tour-introduction';
var TOUR_PRACTICAL_INFORMATION = 'tour-practical-information';
var TOUR_PROGRAM = 'tour-program';
var TRIPADVISOR_TESTIMONY = 'tripadvisor-testimony';
var VIDEO = 'video';

/***/ }),

/***/ "sRHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "wNDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ NotFoundError; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ BadRequest; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ ClientSideError; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ProposalNotFound; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ errors_ApiException; });

// UNUSED EXPORTS: CmsConfigError, RequestFailed, GraphqlError, OfferNotFound, ZoneNotFound, LandingNotFound, ResortNotFound, PriceNotFound, PageNotFound

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__("XcBm");

// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/construct.js


function construct_construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    construct_construct = Reflect.construct.bind();
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(setPrototypeOf["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }
  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function wrapNativeSuper_wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return construct_construct(Class, arguments, Object(getPrototypeOf["a" /* default */])(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(setPrototypeOf["a" /* default */])(Wrapper, Class);
  };
  return wrapNativeSuper_wrapNativeSuper(Class);
}
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/errors/errors.js












function _createSuper(Derived) {
  var hasNativeReflectConstruct = errors_isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}

function errors_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}


var NotFoundError = error_js_default.a.create({
  name: 'NotFoundError',
  message: 'Content not found',
  statusCode: 404,
  redirect: '/404',
  logLevel: 'warn'
});
var BadRequest = error_js_default.a.create({
  name: 'BadRequest',
  message: 'Bad request',
  statusCode: 400,
  logLevel: 'error'
});
var CmsConfigError = error_js_default.a.create({
  name: 'CmsConfigError',
  message: 'Cms configuration error',
  statusCode: 500,
  logLevel: 'error'
});
var RequestFailed = error_js_default.a.create({
  name: 'RequestFailed',
  message: 'Request failed',
  statusCode: 500,
  logLevel: 'error'
});
var GraphqlError = error_js_default.a.create({
  name: 'GraphqlError',
  message: 'Graphql request failed',
  statusCode: 500,
  logLevel: 'error'
});
var ClientSideError = error_js_default.a.create({
  name: 'ClientSideError',
  message: 'Client side error',
  statusCode: 500,
  logLevel: 'error'
});
var OfferNotFound = error_js_default.a.create({
  name: 'OfferNotFound'
}, NotFoundError);
var ZoneNotFound = error_js_default.a.create({
  name: 'ZoneNotFound'
}, NotFoundError);
var LandingNotFound = error_js_default.a.create({
  name: 'LandingNotFound'
}, NotFoundError);
var ResortNotFound = error_js_default.a.create({
  name: 'ResortNotFound'
}, NotFoundError);
var PriceNotFound = error_js_default.a.create({
  name: 'PriceNotFound'
}, NotFoundError);
var ProposalNotFound = error_js_default.a.create({
  name: 'ProposalNotFound'
}, NotFoundError);
var PageNotFound = error_js_default.a.create({
  name: 'PageNotFound'
}, NotFoundError);
var errors_ApiException = /*#__PURE__*/function (_Error) {
  Object(inherits["a" /* default */])(ApiException, _Error);

  var _super = _createSuper(ApiException);

  function ApiException(errors) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ApiException);

    _this = _super.call.apply(_super, [this].concat(Object(toConsumableArray["a" /* default */])(errors)));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "apiErrors", void 0);

    _this.name = 'ApiException';
    _this.apiErrors = errors;
    return _this;
  }

  return ApiException;
}( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));

/***/ })

},[["lWeT",3,1,2,7,0,4,6,8,5,10,9,11,12,13,14,17,21,26,31,33,37]]]);